import advancedCaseStudyTab from "@grindex-areas/CaseStudies/Views/Components/CaseStudyAdvancedPage/js/xyl.views.advanced-casestudy-tab.js";
import countryPrompt from "@grindex-areas/Core/Views/Shared/Partials/js/countryPrompt.module.js";
import countrySelector from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.countryselector.js";
import imageOverview from "@grindex-areas/CommerceCatalog/Views/Shared/Partials/js/imageOverview.module";
import imageRotateSlider from "@grindex-areas/Core/Views/Components/ImageRotateSlider/js/imageRotateSlider";
import navigation from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.navigation";
import productTechnicalDrawings from "@grindex-areas/CommerceCatalog/Views/Shared/Partials/js/productTechnicalDrawings.module";
import sensusDocuments from "@grindex-client/components/Documents/sensusDocuments.js";
import damDocuments from "@grindex-areas/Core/Views/Blocks/DamDocumentListingBlock/damDocuments.js";
import share from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.share.js";
import header from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.header.js";
import singlePromotionHeader from "@grindex-areas/Brand/Views/Shared/Partials/js/xyl.views.singlePromotionHeader";
import performanceCurves from "@grindex-areas/CommerceCatalog/Views/Shared/Partials/js/performanceCurves.module";
import techSpecTables from "@grindex-areas/Core/Views/Shared/Partials/js/techSpecTable.js";
import safeDomainLink from "@grindex-areas/Core/Views/Shared/Partials/js/xyl.views.SafeDomainLink";

const partials = [
	advancedCaseStudyTab,
	countryPrompt,
	countrySelector,
	imageOverview,
	imageRotateSlider,
	navigation,
	productTechnicalDrawings,
	sensusDocuments,
	damDocuments,
	share,
	singlePromotionHeader,
	performanceCurves,
	techSpecTables,
	safeDomainLink,
	header,
];

export { partials };
